import React from "react";
import { Link } from "gatsby";
import SEO from "../components/seo";
import Layout from "../components/layout";
import format from "date-fns/format/index";
import de from "date-fns/locale/de";
import { utcToZonedTime } from "date-fns-tz";
var LeserbriefePage = function LeserbriefePage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Leserbriefe"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange pb-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Leserbriefe"), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap text-lg content-text"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full px-3 lg:px-16"
    }, data.allDatoCmsLetter.nodes.map(function (letter, index) {
        var utcDate = new Date(letter.date).toISOString();
        var zonedDate = utcToZonedTime(utcDate, "Europe/Berlin");
        var formattedDate = format(zonedDate, "dd. MMMM yyyy", {
            locale: de
        });
        console.log(letter);
        return /*#__PURE__*/ React.createElement("div", {
            className: "border-b-2 border-makroGreyLight py-6",
            key: index
        }, /*#__PURE__*/ React.createElement("div", {
            className: "h0 text-makroOrange"
        }, "Leserbrief von ", /*#__PURE__*/ React.createElement("span", {
            className: "italic"
        }, letter.reader), " zum Artikel ", /*#__PURE__*/ React.createElement(Link, {
            to: "/" + letter.article.slug + "/"
        }, /*#__PURE__*/ React.createElement("u", null, letter.article.title)), " (", formattedDate, ")"), /*#__PURE__*/ React.createElement("div", {
            className: "py-3",
            dangerouslySetInnerHTML: {
                __html: letter.text
            }
        }));
    })))));
};
var query = "2547626447";
export default LeserbriefePage;
